export default "__VITE_ASSET__Cd6QhuqH__"